window.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        const texttag = document.querySelector('#real-result .yotpo-reviews-star-ratings-widget .yotpo-sr-bottom-line-summary .sr-only')
        
        if(texttag) {
            const arrayStr = texttag.textContent.split(' ')
            texttag.textContent = arrayStr[0]
        }
       
    }, "1600");
})